<template>
  <div class="wrp">
    <div class="top-header top clear">
      <h1 class="clear">
        <span @click="linkTo('/account')" class="head activate">Venue Account</span>
        <span @click="linkTo('/master')">Master Account</span>
      </h1>
      <div class="date">
        <el-date-picker
          v-model="time"
          type="daterange"
          :range-separator="rangeSeparator"  
          :picker-options="pickerOptions"
          :editable="false"
          :clearable="true"
          format="dd/MM/yyyy"
          @change="format">
        </el-date-picker>
      </div>
      <div class="search">
        <input type="text" @input="watchkey" v-model="key" />
      </div>
    </div>
    <div class="btns clear">
      <button class="light" @click="add">Create New Venue</button>
    </div>
    <div class="table-wrp account" style="min-width:890px">
      <el-table
          :data="tableData2"
          style="width: 100%"
          @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="50">
        </el-table-column>
        <el-table-column
          width="120"
          label="ID">
          <template slot-scope="scope">
            <div>{{scope.row.parentId ? scope.row.parentId + ' - ' + scope.row.id : scope.row.id }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Venue"
          prop="venueName">
        </el-table-column>
        <el-table-column
          label="Username"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="Contact Number"
          prop="venueMobile">
        </el-table-column>
        <el-table-column
          label="Monthly Fee">
          <template slot-scope="scope">
            <div>${{scope.row.monthlyFee}}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="Registration Time"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="Operation"
          width="245">
          <template slot-scope="scope">
            <div class="btns clear d-flex justify-content-center">
              <button class="light" @click="info(scope.row.id)">Details</button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
        </template>
      </el-table>
      <div class="ros_footerPage">
        <el-pagination
            v-if="!loading"
            class="my_pageSel"
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :current-page.sync="page"
            :total="totalRecord">
        </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/account'

export default {
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      time: null, // 选中的原始时间
      startTimeStamp: null, // 选中的开始时间戳(用于传给后端)
      endTimeStamp: null, // 选中的结束时间戳(用于传给后端)
      rangeSeparator: '',
      tableData2: [],
      loading: true, // 是否正在加载
      exportDisable: true, // 导出按钮是否不可用
      totalRecord: 0,
      page: 1,
      pagesize: 10,
      timeout: null,
      key: '',

      current: ''
    }
  },
  created () {
    sessionStorage.removeItem('page')
    sessionStorage.removeItem('startTimeStamp')
    sessionStorage.removeItem('endTimeStamp')
    sessionStorage.removeItem('key')
    sessionStorage.removeItem('time')
    // 下方表格
    if (this.$route.params.page)
      this.page = parseInt(this.$route.params.page)
    if (this.$route.params.startTimeStamp)
      this.startTimeStamp = parseInt(this.$route.params.startTimeStamp)
    if (this.$route.params.endTimeStamp)
      this.endTimeStamp = parseInt(this.$route.params.endTimeStamp)
    if (this.$route.params.key)
      this.key = this.$route.params.key
    if (this.$route.params.time) {
      this.time = this.$route.params.time.split(',')
      this.rangeSeparator = '-'
    }

    const data = {
      pageNum: this.page,
      pageSize: this.pagesize
    }
    if (this.startTimeStamp)
      data.createTimeBegin = this.startTimeStamp
    if (this.endTimeStamp)
      data.createTimeEnd = this.endTimeStamp
    if (this.key.replace(/\s+/g,'') !== '')
      data.keyword = this.key
    api.getLst({
      params: data, 
      callback: this.lstCallback
    })
  },
  methods: {
    linkTo (path) {
      this.$router.push(path)
    },
    format (e) {
      let data
      if (e) {
        this.rangeSeparator = '-'
        this.startTimeStamp = e[0].getTime()
        this.endTimeStamp = e[1].getTime() + 86400000 - 1
        data = {
          createTimeBegin: this.startTimeStamp,
          createTimeEnd: this.endTimeStamp,
          pageNum: this.page,
          pageSize: this.pagesize
        }
      } else {
        this.rangeSeparator = ''
        this.startTimeStamp = null
        this.endTimeStamp = null
        data = {
          pageNum: this.page,
          pageSize: this.pagesize
        }
      }
      if (this.key.replace(/\s+/g,'') !== '')
        data.keyword = this.key
      this.tableData2 = []
      this.loading = true
      api.getLst({
        params: data, 
        callback: this.lstCallback
      })
    },
    excelCallback () {},
    handleSelectionChange (val) {
      var that = this
      if (val.length > 0) {
        that.exportDisable = false
        let temp = []
        val.forEach(item => {
          temp.push(item.id)
        })
        that.current = temp.join(',')
      } else {
        that.exportDisable = true
      }
    },
    // 新增venue
    add () {
      this.$router.push('/create')
    },
    info (id) {
      this.$router.push(`/detail/info/${id}`)
      sessionStorage.setItem('page', this.page)
      if (this.startTimeStamp)
        sessionStorage.setItem('startTimeStamp', this.startTimeStamp)
      if (this.endTimeStamp)
        sessionStorage.setItem('endTimeStamp', this.endTimeStamp)
      if (this.key.replace(/\s+/g,'') !== '')
        sessionStorage.setItem('key', this.key)
      if (this.time)
        sessionStorage.setItem('time', this.time)
    },
    pageChange (page) {
      this.page = page
      this.tableData2 = []
      this.loading = true
      // 加载表格
      const data = {
        pageNum: this.page,
        pageSize: this.pagesize
      }
      if (this.startTimeStamp)
        data.createTimeBegin = this.startTimeStamp
      if (this.endTimeStamp)
        data.createTimeEnd = this.endTimeStamp
      if (this.key.replace(/\s+/g,'') !== '')
        data.keyword = this.key
      this.tableData2 = []
      this.loading = true
      api.getLst({
        params: data, 
        callback: this.lstCallback
      })
    },
    lstCallback (res) {
      var that = this
      if(res.data.code == 0){
        // 等待接口
        if (this.page !== 1 && res.data.data.list.length === 0) {
          this.page -- 
          api.getLst({
            params: {
              //createTimeBegin: 0,
              //createTimeEnd: 9999999999999,
              //keyword: this.key,
              pageNum: this.page,
              pageSize: this.pagesize
            }, 
            callback: this.lstCallback
          })
        } else {
          that.loading = false
          res.data.data.list.forEach(item => {
            item.createTime = that.$box.timestampToTime(item.createTime)
            item.venueMobile = that.$box.formatNumber(item.venueMobile)
            item.monthlyFee = Utils.formatSplit(item.monthlyFee)
          })
          this.tableData2 = res.data.data.list
          this.totalRecord = res.data.data.total
        }
      } else{
        that.loading = false
        Utils.alert('', res.data.message, 'error')
      }
    },
    // 搜索关键词，
    keySearch (key) {
      this.page = 1
      const data = {
        keyword: this.key,
        pageNum: 1,
        pageSize: this.pagesize
      }
      if (this.startTimeStamp)
        data.createTimeBegin = this.startTimeStamp
      if (this.endTimeStamp)
        data.createTimeEnd = this.endTimeStamp
      this.tableData2 = []
      this.loading = true
      this.totalRecord = 0
      api.getLst({
        params: data, 
        callback: this.lstCallback
      })
    },
    watchkey() {
      var that = this
      if (that.timeout) {
          clearTimeout(that.timeout)
      }
      that.timeout = setTimeout(() => {
          that.keySearch.call(that, that.key)
      }, 2000) 
    }
  },
  /*watch: {
      'key': {
          deep: true,
          handler: function (val) {
              var that = this
              if (that.timeout) {
                  clearTimeout(that.timeout)
              }
              that.timeout = setTimeout(() => {
                  that.keySearch.call(that, val)
              }, 2000) 
          }
      }
  }*/
}
</script>

<style lang="scss" scoped>
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
.ros_footerPage{
    display: flex;
    justify-content: center;
}
.wrp{
  color: #fff;
  padding-bottom: 50px;
  .top{
    width: 100%;
    margin-bottom: 48px;
    h1{
      span{
        float: left;
        margin-right: 40px;
        position: relative;
        cursor: pointer;
        
      }

      
      .activate {
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: 41px;
          width: 100%;
          height: 2px;
          background: #EA3796;
        }
      }
    }
    .date{
      float: left;
      margin-top: -10px;
      position: relative;
      background-repeat: no-repeat;
      background-position: right center;
      background-size: 23px 23px;
      background-image: url('../../assets/c.png');
      .show{
        position: absolute;
        width: 100%;
        height: 40px;
        left: 0;
        top: 0;
      }
    }
    .search{
      float: right;
      width: 300px;
      border-bottom: 1px solid #fff;
      background-size: 24px 22px;
      background-position: left center;
      background-repeat: no-repeat;
      background-image: url('../../assets/s.png');
      margin-top: -3px;
      input{
        outline: none;
        border: none;
        line-height: 30px;
        font-size: 16px;
        font-family:'PingFangSC-Regular,PingFang SC';
        width: 100%;
        background-color: transparent;
        color: #fff;
        box-sizing: border-box;
        padding-left: 30px;
      }
    }
  }
  .btns{
    width: 100%;
    margin-bottom: 30px;
    button{
      outline: none;
      border: none;
      height: 60px;
      font-family: 'PingFangSC-Semibold';
      font-size: 26px;
      background-color: transparent;
    }
    .light{
      width: 280px;
      border: 1px solid #EA3796;
      margin-right: 30px;
      color: #EA3796;
      cursor: pointer;
    }
    .dark{
      border: 1px solid #FFFFFF;
      color: #FFFFFF;
      width: 200px;
      cursor: pointer;
    }
    .disable{
      border: 1px solid gray;
      color: gray;
      cursor: not-allowed;
    }
  }
  .table-wrp{
    .btns{
      margin-bottom: 0;
    }
    button{
      height: 40px;
      font-size: 18px;
    }
    .light{
      width: 100px;
      margin-right: 10px;
    }
    .dark{
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/index.vue